import { DIAS_SEMANA_ABREV, formatarDataCurta, parseDataISO } from "../../../shared/lib/date";

const WEEKDAY_NAMES = ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
// No mensal a frase fica longa: "Toda 3ª quarta do mês" em vez de "quarta-feira".
const WEEKDAY_SHORT_NAMES = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];
const MASCULINE_WEEKDAYS = new Set([0, 6]);

export const LAST_WEEK_OF_MONTH = -1;

export const FREQUENCY_OPTIONS = [
  { value: "weekly", label: "Semanal (toda semana)" },
  { value: "biweekly", label: "Quinzenal (semana sim, semana não)" },
  { value: "monthly", label: "Mensal (ex.: 1º sábado do mês)" },
];

export const WEEK_OF_MONTH_OPTIONS = [
  { value: 1, label: "1ª" },
  { value: 2, label: "2ª" },
  { value: 3, label: "3ª" },
  { value: 4, label: "4ª" },
  { value: LAST_WEEK_OF_MONTH, label: "Última" },
];

export const WEEKDAY_OPTIONS = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"].map((label, value) => ({
  value,
  label,
}));

function ordinal(weekOfMonth, masculine) {
  if (weekOfMonth === LAST_WEEK_OF_MONTH) return masculine ? "último" : "última";
  return `${weekOfMonth}${masculine ? "º" : "ª"}`;
}

function describeRule({ weekday, frequency, week_of_month: weekOfMonth }) {
  const masculine = MASCULINE_WEEKDAYS.has(weekday);
  const every = masculine ? "Todo" : "Toda";
  if (frequency === "monthly") {
    return `${every} ${ordinal(weekOfMonth, masculine)} ${WEEKDAY_SHORT_NAMES[weekday]} do mês`;
  }
  const day = WEEKDAY_NAMES[weekday];
  if (frequency === "biweekly") return `${day[0].toUpperCase()}${day.slice(1)}, semana sim, semana não`;
  return `${every} ${day}`;
}

// "Toda segunda-feira" / "Segunda-feira, semana sim, semana não" / "Todo 1º sábado do mês"
// + desde quando vale (no mensal, a primeira ocorrência).
export function describeShiftPattern(pattern) {
  return { rule: describeRule(pattern), since: `a partir de ${formatarDataCurta(parseDataISO(pattern.start_date))}` };
}

// "Seg, 03/11" para a lista da prévia (data vem "yyyy-MM-dd").
export function formatScheduleDate(isoDate) {
  const date = parseDataISO(isoDate);
  return `${DIAS_SEMANA_ABREV[date.getDay()]}, ${formatarDataCurta(date).slice(0, 5)}`;
}
